import React from 'react';

function SearchPage(props:any) {
    return (
        <div></div>
    );
}

export default SearchPage;